import React from "react";
import Generate from "../containers/Generate/Generate";
import { Route, Redirect } from "react-router-dom";
import AmazonDescResultbox from "../Components/Generate/GenerateBody/ResultBox/AmazonDesc/AmazonDescResultbox";
import AmazonDesc from "../Components/Generate/GenerateBody/GenerateSidebar/AmazonDesc/AmazonDesc";
import LinkedlnResultbox from "../Components/Generate/GenerateBody/ResultBox/LinkedlnAd/LinkedlnResultbox";
import LinkedlnAd from "../Components/Generate/GenerateBody/GenerateSidebar/LinkedlnAd/LinkedlnAd";
import CommonResultbox from "../Components/Generate/GenerateBody/ResultBox/Common/CommonResultbox";
import Caption from "../Components/Generate/GenerateBody/GenerateSidebar/Captions/Captions";
import GoogleAdResultbox from "../Components/Generate/GenerateBody/ResultBox/GoogleAd/GoogleAdResultBox";
import GoogleAd from "../Components/Generate/GenerateBody/GenerateSidebar/GoogleAd/GoogleAd";
import InstagramAd from "../Components/Generate/GenerateBody/GenerateSidebar/InstagramAd/InstagramAd";
import InstragramAdResultbox from "../Components/Generate/GenerateBody/ResultBox/InstagramAd/InstagramAdResultbox";
import SEOMetatag from "../Components/Generate/GenerateBody/GenerateSidebar/SEOMetatag/SEOMetatag";
import SEOMetatagResultbox from "../Components/Generate/GenerateBody/ResultBox/SEOMetatag/SEOMetatagResultbox";
import Tagline from "../Components/Generate/GenerateBody/GenerateSidebar/Tagline/Tagline";
import BlogOutline from "../Components/Generate/GenerateBody/GenerateSidebar/BlogOutline/BlogOutline";
import BlogIdeas from "../Components/Generate/GenerateBody/GenerateSidebar/BlogIdeas/BlogIdeas";
import BlogQuote from "../Components/Generate/GenerateBody/GenerateSidebar/BlogQuote/BlogQuote";
import BlogIntro from '../Components/Generate/GenerateBody/GenerateSidebar/BlogIntro/BlogIntro';
import DisplayAds from "../Components/Generate/GenerateBody/GenerateSidebar/DisplayAds/DisplayAds";
import Faq from "../Components/Generate/GenerateBody/GenerateSidebar/FAQ/faq";
import PainAgitate from '../Components/Generate/GenerateBody/GenerateSidebar/PainAgitate/PainAgitate';
import FacebookAd from "../Components/Generate/GenerateBody/GenerateSidebar/FacebookAd/FacebookAd";

function GenerateRoute() {
  return (
    <>
      <Route exact path="/generate">
        <Redirect to="/home"></Redirect>
      </Route>
      <Route exact path="/generate/amazondesc">
        <Generate
          resultBox={<AmazonDescResultbox />}
          sidebar={<AmazonDesc />}
          header="Amazon Product Description"
          type="amazonDesc"
        />
      </Route>
      <Route exact path="/generate/caption">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<Caption />}
          header="Captions"
        />
      </Route>
      <Route exact path="/generate/instagramAd">
        <Generate
          resultBox={<InstragramAdResultbox />}
          sidebar={<InstagramAd />}
          header="Instagram Ad"
        />
      </Route>
      <Route exact path="/generate/linkedlnAd">
        <Generate
          resultBox={<LinkedlnResultbox />}
          sidebar={<LinkedlnAd />}
          header="Linkedln Ad"
          type="LINKEDIN_ADD"
        />
      </Route>
      <Route exact path="/generate/googleAd">
        <Generate
          resultBox={<GoogleAdResultbox />}
          sidebar={<GoogleAd />}
          header="Google Ad"
          type="GOOGLE_ADD"
        />
      </Route>
      <Route exact path="/generate/SEOmetatag">
        <Generate
          resultBox={<SEOMetatagResultbox />}
          sidebar={<SEOMetatag />}
          header="SEO Metatag"
        />
      </Route>
      <Route exact path="/generate/taglines">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<Tagline />}
          header="Taglines"
          type="TAGLINE"
        />
      </Route>
      <Route exact path="/generate/file/amazondesc/:fileId">
        <Generate
          resultBox={<AmazonDescResultbox />}
          sidebar={<AmazonDesc />}
          header="Amazon Product Description"
          type="amazonDesc"
        />
      </Route>
      <Route exact path="/generate/file/caption/:fileId">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<Caption />}
          header="Captions"
        />
      </Route>
      <Route exact path="/generate/file/instagramAd/:fileId">
        <Generate
          resultBox={<InstragramAdResultbox />}
          sidebar={<InstagramAd />}
          header="Instagram Ad"
        />
      </Route>
      <Route exact path="/generate/file/linkedlnAd/:fileId">
        <Generate
          resultBox={<LinkedlnResultbox />}
          sidebar={<LinkedlnAd />}
          header="Linkedln Ad"
          type="LINKEDIN_ADD"
        />
      </Route>
      <Route exact path="/generate/file/googleAd/:fileId">
        <Generate
          resultBox={<GoogleAdResultbox />}
          sidebar={<GoogleAd />}
          header="Google Ad"
          type="GOOGLE_ADD"
        />
      </Route>
      <Route exact path="/generate/file/SEOmetatag/:fileId">
        <Generate
          resultBox={<SEOMetatagResultbox />}
          sidebar={<SEOMetatag />}
          header="SEO Metatag"
        />
      </Route>
      <Route exact path="/generate/file/taglines/:fileId">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<Tagline />}
          header="Taglines"
          type="TAGLINE"
        />
      </Route>
      <Route exact path="/generate/BlogOutline">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<BlogOutline />}
          header="Blog Outline"
          type="Blog Outline"
        />
      </Route>
      <Route exact path="/generate/BlogIdeas">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<BlogIdeas />}
          header="Blog Ideas"
          type="BLOG_IDEAS"
        />
      </Route>
      <Route exact path="/generate/BlogQuote">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<BlogQuote />}
          header="Blog Quote"
          type="BLOG_QUOTE"
        />
      </Route>
      <Route exact path="/generate/BlogIntro">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<BlogIntro />}
          header="Blog Intro"
          type="BLOG_INTRO"
        />
      </Route>
      <Route exact path="/generate/file/BlogIdeas/:fileId">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<BlogIdeas />}
          header="Blog Ideas"
          type="BLOG_IDEAS"
        />
      </Route>
      <Route exact path="/generate/file/BlogIntro/:fileId">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<BlogIntro />}
          header="Blog Intro"
          type="BLOG_INTRO"
        />
      </Route>
      <Route exact path="/generate/file/BlogQuote/:fileId">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<BlogQuote />}
          header="Blog Quote"
          type="BLOG_QUOTE"
        />
      </Route>
      <Route exact path="/generate/DisplayAds">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<DisplayAds />}
          header="Display Ads"
          type="DISPLAY_ADS"
        />
      </Route>
      <Route exact path="/generate/file/DisplayAds/:fileId">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<DisplayAds />}
          header="Display Ads"
          type="DISPLAY_ADS"
        />
      </Route>
      <Route exact path="/generate/Faq">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<Faq />}
          header="FAQ Ideas"
          type="FAQ"
        />
      </Route>
      <Route exact path="/generate/PainAgitate">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<PainAgitate />}
          header="Pain Solutions"
          type="PAIN_AGITATE_SOLUTION"
        />
      </Route>
      <Route exact path="/generate/file/PainAgitate/:fileId">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<PainAgitate />}
          header="Pain Solutions"
          type="PAIN_AGITATE_SOLUTION"
        />
      </Route>
      <Route exact path="/generate/file/Faq/:fileId">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<Faq />}
          header="FAQ IDEAS"
          type="FAQ"
        />
      </Route>
      <Route exact path="/generate/facebookAd">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<FacebookAd />}
          header="Facebook Ad"
          type="FACEBOOK_ADD"
        />
      </Route>
      <Route exact path="/generate/file/facebookAd/:fileId">
        <Generate
          resultBox={<CommonResultbox />}
          sidebar={<FacebookAd/>}
          header="Facebook Add"
          type="FACEBOOK_ADD"
        />
      </Route>

    </>
  );
}

export default GenerateRoute;
